import React, { useState } from 'react';
import { ulid } from 'ulid';
import ImageSelectorInternal from './ImageSelector';

const useImageSelector = (props: Omit<
    React.ComponentProps<typeof ImageSelectorInternal>,
    'imageRefreshKey'
>) => {
    const [key, setKey] = useState(ulid());
    return {
        resetImageSelector: () => setKey(ulid()),
        imageSelector: <ImageSelectorInternal {...props} imageRefreshKey={key} />,
    };
};
export default useImageSelector;
